import _classCallCheck from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _taggedTemplateLiteral from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2;
import { Ge as d, hi as g, bo as v, M as c, fi as p } from "./abstract-base-8edf0a84-e11d45a3.js";
var u = d(_templateObject || (_templateObject = _taggedTemplateLiteral([":host{--icon: url(\"data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='8' cy='8' r='8' fill='%23DD3636'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M8 3.75C7.72386 3.75 7.5 3.97386 7.5 4.25V9.25C7.5 9.52614 7.72386 9.75 8 9.75C8.27614 9.75 8.5 9.52614 8.5 9.25V4.25C8.5 3.97386 8.27614 3.75 8 3.75ZM8 12.25C8.41421 12.25 8.75 11.9142 8.75 11.5C8.75 11.0858 8.41421 10.75 8 10.75C7.58579 10.75 7.25 11.0858 7.25 11.5C7.25 11.9142 7.58579 12.25 8 12.25Z' fill='white'/%3E%3C/svg%3E%0A\");margin-block-end:var(--beacon-unit-subatomic);padding-block-start:var(--beacon-unit-subatomic)}:host([is-valid]){--icon: url(\"data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='8' cy='8' r='8' fill='%23248647'/%3E%3Cpath d='M5 8.71605L6.99561 10.5833L10.4167 6' stroke='white' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\")}.text{font:var(--beacon-system-font-weight-bold, var(--beacon-font-weight-bold)) var(--beacon-system-font-size-sans-serif-caption-300, var(--beacon-caption-font-size-300)/var(--beacon-caption-font-line-height-module-300) var(--beacon-font-family-default));align-items:center;color:var(--beacon-color-text-important);display:flex}.text:before{block-size:calc(1.25 * var(--beacon-unit-base));content:\"\";inline-size:calc(1.25 * var(--beacon-unit-base));margin-inline-end:calc(.625 * var(--beacon-unit-base));min-inline-size:calc(1.25 * var(--beacon-unit-base));background-image:var(--icon);background-position:center;background-repeat:no-repeat}\n"])));
var h = Object.defineProperty,
  m = Object.getOwnPropertyDescriptor,
  l = function l(a, e, o, n) {
    for (var t = n > 1 ? void 0 : n ? m(e, o) : e, i = a.length - 1, r; i >= 0; i--) (r = a[i]) && (t = (n ? r(e, o, t) : r(t)) || t);
    return n && t && h(e, o, t), t;
  };
var b = "beacon-error";
var s = /*#__PURE__*/function (_g) {
  _inherits(s, _g);
  function s() {
    var _this;
    _classCallCheck(this, s);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(s).apply(this, arguments)), _this.beaconTagName = b, _this.isValid = !1, _this.message = "";
    return _this;
  }
  _createClass(s, [{
    key: "render",
    value: function render() {
      return v(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["<span class=\"text ", "\">", "</span>"])), this.isValid ? "valid" : "error", this.message);
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      var e;
      (e = this.handleDefer()) == null || e.then(function () {
        _get(_getPrototypeOf(s.prototype), "connectedCallback", _this2).call(_this2);
      });
    }
  }], [{
    key: "styles",
    get: function get() {
      return [_get(_getPrototypeOf(s), "styles", this), u];
    }
  }]);
  return s;
}(g(p));
s.tagName = b;
l([c({
  attribute: "is-valid",
  type: Boolean,
  reflect: !0
})], s.prototype, "isValid", 2);
l([c()], s.prototype, "message", 2);
export { s as BeaconError };